import academics from './academics';
import account from './account';
import agGrid from './aggrid';
import alert from './alert';
import aoi from './aoi';
import attestations from './attestations';
import authentication from './authentication';
import boardCerts from './boardCerts';
import certs from './certs';
import chatbot from './chatbot';
import malpracticeClaims from './claims';
import cmeTraining from './cmeTraining';
import components from './components';
import confirmationDialog from './confirmationDialog';
import dashboard from './dashboard';
import delegation from './delegation';
import documents from './documents';
import employer from './employer';
import employment from './employment';
import facility from './facility';
import malpracticeInsurance from './insurance';
import genericJSONForm from './jsonForms';
import layout from './layout';
import listingSearch from './listing-search';
import malpractice from './malpractice';
import marketResponses from './market-responses';
import medicalLicenses from './medicalLicenses';
import notFoundPage from './notFoundPage';
import notifications from './notifications';
import peerReference from './peerReference';
import peerReferenceReq from './peerReferenceReq';
import privileges from './privileges';
import profile from './profile';
import providerSettings from './providerSettings';
import registration from './registration';
import tutorialVideo from './tutorialVideo';
import verifyAssociation from './verifyAssociation';

export default {
  Homepage: {
    signinBtn: 'sign-in-button',
    dashboardBtn: 'dashboard-button',
    signoutBtn: 'sign-out-button',
  },
  UserTypeSelect: {
    providerButton: 'provider-signup-button',
    employerButton: 'employer-signup-button',
  },
  ToolBar: {
    bellIcon: 'tool-bell-icon',
  },
  agGrid: agGrid,
  alert: alert,
  attestations: attestations,
  aoi: aoi,
  academics: academics,
  account: account,
  authentication: authentication,
  boardCerts: boardCerts,
  certs: certs,
  chatbot: chatbot,
  cmeTraining: cmeTraining,
  confirmationDialog: confirmationDialog,
  dashboard: dashboard,
  documents: documents,
  employment: employment,
  facility: facility,
  genericJSONForm: genericJSONForm,
  layout: layout,
  malpractice: malpractice,
  malpracticeClaims: malpracticeClaims,
  malpracticeInsurance: malpracticeInsurance,
  marketResponses: marketResponses,
  medicalLicenses: medicalLicenses,
  notifications: notifications,
  peerRef: peerReference,
  peerRefReq: peerReferenceReq,
  privileges: privileges,
  profile: profile,
  employer: employer,
  components: components,
  delegation: delegation,
  providerSettings: providerSettings,
  registration: registration,
  verifyAssociation: verifyAssociation,
  notFound: notFoundPage,
  listingSearch: listingSearch,
  tutorialVideo: tutorialVideo,
};
